var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeaker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 3h15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 3v7a6 6 0 1 0 12 0V3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13h6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeaker);
export default __webpack_public_path__ + "static/media/Beaker.d0ce7c7f93a2db83dca0553bd334f26f.svg";
export { ForwardRef as ReactComponent };